import { Category, CategoryEntity } from "./Category";

export interface GameData {
  categories: Array<Category>;
  firstTeamName: string;
  secondTeamName: string;
  currentTeamTurn: TeamTurns;
  firstTeamScore: number;
  secondTeamScore: number;
  resultGame?: Game;
}

export interface GameDetails {
  selectedCategories: Array<CategoryEntity | string>;
  pointsHashmaps: Array<string>;
  firstTeamName: string;
  secondTeamName: string;
  currentTeamTurn: TeamTurns;
  firstTeamScore: number;
  secondTeamScore: number;
}

export interface UpdateGameRequestModel {
  id: string;
  details?: GameDetails;
  isCompleted?: boolean;
}

export interface Game {
  _id?: string;
  details?: GameDetails;
  createdAt?: Date;
}

export interface GiveRatingRequestModel {
  feedback?: string;
  rate: number;
}

export enum TeamTurns {
  teamA = "teamA",
  teamB = "teamB",
}
